<template>
    <div class="content">
        <el-row>
        <el-col :span="2"><div class="grid-content"></div></el-col>
        <el-col :span="6">
            <div class="grid-content MyPhoto">
                <img class="photoimg" src="../assets/photo1.jpg.webp">
                <p class="info">Photo Credit: YU Xutao 2021.10</p>
            </div>

        </el-col>
        <el-col :span="6">
            <div class="grid-content MyPhoto">
                <img class="photoimg" src="../assets/photo2.jpg.webp">
                <p class="info">Photo Credit: QIN Yixiang&CHEN Chao 2023.12</p>
            </div>
        </el-col>
        <el-col :span="8">
            <div class="grid-content"></div>
        </el-col>

        <el-col :span="2"><div class="grid-content"></div></el-col>


    </el-row>
        <el-row>
            <el-col :span="2"><div class="grid-content"></div></el-col>
            <el-col :span="6">
                <div class="grid-content"></div>
            </el-col>
            <el-col :span="6">
                <div class="grid-content"></div>
            </el-col>
            <el-col :span="8">
                <div class="grid-content about-content">
                    <h1>ABOUT</h1>
                    <p class="paragraph">
                        Qing Gong received the B.S. degree in industrial design from Zhejiang University in 2019, and the Ph.D. degree in design science from the College of Computer Science and Technology, Zhejiang University, in 2024. In 2024, she joined the Yangtze River Delta Innovation Center of Zhejiang University as a postdoctoral researcher. Her research interests include human-computer interaction, and traditional culture and digital creativity.
                        <br><br> Her current research direction is mainly focused on virtual reality, attempting to explore the human-machine interaction issues of virtual reality from the perspectives of engineering and social sciences, in order to achieve the link between virtual reality and design. She attempts to explore and create new concepts in the field of design through new technological applications and empirical research, enhance the influence of the design discipline itself through interdisciplinary integration, and use this as a medium to explore the truth of the world.
                        <br><br>  In order to pursue scientific research, she possesses basic design skills, including visual communication, product design, interaction design, etc. At the same time, she read some classic literature on social sciences and mastered some research methods. In addition, she has mastered basic programming skills, including university foundation courses focused on C++, Unity project development based on C #, front-end and back-end separation project development based on VUE3 and Springboot, and hardware development on the Arduino platform.
                    </p>
                </div>
            </el-col>

            <el-col :span="2"><div class="grid-content"></div></el-col>


        </el-row>
    </div>
</template>

<script>
    export default {
        name: "About",

    }
</script>

<style scoped>
    .MyPhoto{
        width: 20vw;
        height: 20vw;
    }
    .photoimg {
        max-height:100%;

    }
    .about-content{
        margin: -20px  0 0 40px;
        line-height:25px;
    }
    .paragraph{
        font-size: 15px;
        color: #333;
        font-weight: 100;
        text-align: justify;

    }
    h1{
        font-size:30px;
        font-weight: 100;
        letter-spacing:6px;
        padding-top: 50px;
        border-top: black 1px solid;
    }
    .grid-content {
        min-height: 36px;
        border:none;

    }
    .content{
        margin-top:100px;
    }

    .info{
        font-size: 8px;
        color: #666;
        font-weight: 100;
    }
</style>
